//Bibliotecas
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
//Componentes material
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import { withStyles } from '@material-ui/core';
//Componentes
import Layout from './Layout';
import VitalizePaper from '../components/VitalizePaper';
import LabelSecao from '../components/LabelSecao';
import MaskedInput from 'react-text-mask';
import VitalizeFab from '../components/VitalizeFab';
//Controllers
import AvaliadorController from '../controllers/AvaliadorController';
import EmpresaController from '../controllers/EmpresaController';
import PermissaoController, { perfilAcesso } from '../controllers/PermissaoController';
//Utils
import deepCopy from '../utils/deepCopy';
import { converterNumero } from '../utils/validacao';
//Models
import Avaliador from '../models/Avaliador';

const styles = () => ({
    secaoPermissoes: {
        width: '100%'
    },
    grupoPermissoes: {
        width: '100%',
        flexDirection: 'row'
    }
});

/**
 * Página com um formulário para edição e inclusão de avaliadores
 */
class AvaliadorFormPage extends React.Component {

    constructor(props) {
        super(props);
        //Bindings
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleEmpresaChange = this.handleEmpresaChange.bind(this);
        this.getEmpresaLabel = this.getEmpresaLabel.bind(this);
        this.getEmpresaSelected = this.getEmpresaSelected.bind(this);
        this.handlePermissoesChange = this.handlePermissoesChange.bind(this);
        //Controller
        this.avaliadorController = new AvaliadorController();
        this.empresaController = new EmpresaController();
        this.permissaoController = new PermissaoController();
        //Estado inicial
        this.state = {
            valores: Avaliador.clone({ nome: '', email: '', telefone: '', senha: '', permissoes: [ ], empresa: null }),
            erros: {
                nome: '',
                email: '',
                telefone: '',
                senha: '',
                empresa: '',
                permissoes: ''
            },
            empresas: [],
            permissoes: [],
            sucesso: false,
            processando: false,
            carregando: true,
            permiteSelecionarEmpresa: false
        };
    }

    /**
     * Carrega os dados do avaliador sendo editado e dos gêneros
     */
    async componentDidMount() {
        const id = this.getId();
        const state = Object.assign({}, this.state);
        state.carregando = false; //Indica que a consulta terminou
        //Consulta os gêneros
        state.permissoes = await this.obterPermissoes();
        
        //Consulta as empresas
        state.permiteSelecionarEmpresa = await this.permissaoController.permiteSelecionarEmpresa();
        if (state.permiteSelecionarEmpresa)
            state.empresas = await this.obterEmpresas();

        if (id > 0)
        {
            //Carrega o avaliador
            const result = await this.avaliadorController.obter(id);
            if (result.sucesso) {
                state.valores = result.avaliador;
            }
        }

        this.setState(state);
    }

    /**
     * Carrega os gêneros da API
     */
    async obterPermissoes() {
        const result = await this.permissaoController.listarPermissoes(perfilAcesso.AVALIADOR);
        if (result.sucesso) 
            return result.items;
        else
            return [];
    }

    /**
     * Carrega as empresas da API
     */
    async obterEmpresas() {
        const result = await this.empresaController.listarSelecao();
        if (result.sucesso) 
            return result.items;
        else
            return [];
    }

    /**
     * Recupera o Id do avaliador a ser editado dos parâmetros da URL
     */
    getId() {
        let id;
        if (this.props.match)
            id = this.props.match.params.id;
        if (id === 'add')
            return 0;
        else
            return parseInt(id);
    }

    /**
     * Trata a alteração do campo empresa
     * @param {*} evt Objeto contendo os dados do evento
     * @param {Object} novaEmpresa Dados da empresa selecionada
     */
    async handleEmpresaChange(evt, novaEmpresa) {
        //Cria uma cópia do estado atual e atualiza o campo
        const state = deepCopy(this.state);
        state.valores.empresa = novaEmpresa;
        //Atualiza o estado da página
        this.setState(state);
    }
    
    /**
     * Retorna os dados da empresa para exibição no campo
     * @param {Object} empresa Dados da empresa
     * @param {String} empresa.nome Nome da empresa
     * @returns {String} Retorna o nome da empresa
     */
    getEmpresaLabel(empresa) {
        return empresa.nome;
    }

    /**
     * Verifica se o item do campo está selecionado
     * @param {Object} opcao Opção exibida no campo
     * @param {Number} opcao.id Identificação da empresa
     * @param {Object} valor Opção selecionada
     * @param {Number} valor.id Identificação da empresa selecionada
     * @returns {Boolean} Retorna verdadeiro caso a opção esteja selecionada
     */
    getEmpresaSelected(opcao, valor) {
        //Compara a identificação das duas empresas
        return opcao.id === valor.id;
    }

    /**
     * Trata as alterações nos campos do formulário e atualiza o state
     * @param {*} event Objeto contendo os dados do evento
     */
    handleChange(event) {
        //Cria uma cópia do estado atual
        const valores = Avaliador.clone(this.state.valores);
        //Atualiza somente o valor do campo alterado
        valores[event.target.name] = event.target.value;
        //Atualiza o estado
        this.setState({ valores });
    }

    /**
     * Trata as alterações nas permissões selecionadas
     * @param {*} event Objeto contendo os dados do evento
     */
    handlePermissoesChange(event) {
        //Cria uma cópia dos dados do avalidor
        const valores = Avaliador.clone(this.state.valores);
        //Converte o valor da permissão selecionada
        const id = converterNumero(event.target.value);
        //Caso o usuário tenha marcado uma opção
        if (event.target.checked)
            valores.permissoes.push(this.state.permissoes.find(item => item.id === id));
        else //Caso o usuário tenha desmarcado a opção
            valores.permissoes = valores.permissoes.filter(item => item.id !== id);
        //Atualiza o estado
        this.setState({ valores });
    }

    /**
     * Executa quando o form é submetido.
     * Envia os dados para a API
     * @param {*} event Objeto contendo os dados do evento
     */
    async handleSubmit(event) {
        let result;
        //Impede a propagação do evento
        event.preventDefault();
        //Exibe loader
        this.setState({ processando: true });
        //Cria uma cópia do estado atual
        const state = Object.assign({}, this.state);
        state.processando = false; //Indica que o processamento terminou
        //Salva o registro
        const id = this.getId();
        
        if (id === 0)
            result = await this.avaliadorController.salvar(state.valores);
        else
            result = await this.avaliadorController.atualizar(state.valores);

        state.sucesso = result.sucesso;
        if (!result.sucesso) {
            state.erros = this.extrairMensagemErro(result);
        }
        this.setState(state);
    }

    /**
     * Retorna as mensagens de erro da API para exibição no formulário
     * @param {*} resultado Retorno do método salvar da API
     */
    extrairMensagemErro(resultado) {
        const erros = {
            nome: '',
            email: '',
            telefone: '',
            senha: '',
            empresa: '',
            permissoes: ''
        };

        for (let erro of resultado.erros) {
            if (erro.campo === 'nome')
                erros.nome = erro.mensagem;
            if (erro.campo === 'email')
                erros.email = erro.mensagem;
            if (erro.campo === 'telefone')
                erros.telefone = erro.mensagem;
            if (erro.campo === 'senha')
                erros.senha = erro.mensagem;
            if (erro.campo === 'empresa')
                erros.empresa = erro.mensagem;
            if (erro.campo === 'permissoes')
                erros.permissoes = erro.mensagem;
        }

        return erros;
    }

    /**
     * Verifica se o usuário possui a permissão informada
     * @param {Permissao} permissao Permissão a ser verificada
     * @returns {Boolean} Retorna verdadeiro caso o usuário possua a permissão
     */
    verificarPermissaoSelecionada(permissao) {
        const permissoes = this.state.valores.permissoes;
        return !!permissoes.find(item => item.id === permissao.id);
    }

    /**
     * Renderiza o campo de seleção de empresa, caso o usuário possua permissão 
     * @param {Boolean} permiteSelecionarEmpresa Indica se o usuário pode selecionar uma empresa
     * @param {Empresa} empresa Valor selecionado
     * @param {String} empresaErro Mensagem de erro do campo
     * @param {Array<Empresa>} empresas Lista de empresas retornadas da API
     * @returns {React.Component} Retorna o componente ou null
     */
    renderCampoEmpresas(permiteSelecionarEmpresa, empresa, empresaErro, empresas) {
        if (permiteSelecionarEmpresa)
            return (
                <Grid item xs={12} >
                    <Autocomplete
                        id="select-empresa"
                        options={empresas}
                        value={empresa}
                        getOptionLabel={this.getEmpresaLabel}
                        getOptionSelected={this.getEmpresaSelected}
                        onChange={this.handleEmpresaChange}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                id="empresa"
                                name="empresa" 
                                label="Empresa"
                                required
                                variant="outlined" 
                                error={!!empresaErro}
                                helperText={empresaErro}
                                fullWidth 
                            />
                        )}
                    />
                </Grid>
            );
        else
            return null;
    }

    render() {
        const { onLogout, classes, usuario, empresa: empresaLogin, permissoes: modulosPermitidos } = this.props;
        const { sucesso, permissoes, empresas, permiteSelecionarEmpresa, processando, carregando } = this.state;
        const { 
            nome, 
            email,
            telefone, 
            senha,
            empresa
        } = this.state.valores;
        
        const { 
            nome: nomeErro, 
            email: emailErro, 
            telefone: telefoneErro, 
            senha: senhaErro,
            empresa: empresaErro,
            permissoes: permissoesErro
        } = this.state.erros;

        let senhaHelper = senhaErro;
        if (this.getId() > 0 && senhaHelper === '')
            senhaHelper = 'Deixe vazio para manter a senha';

        if (sucesso) return (<Redirect to="/avaliador" />);

        return (
            <Layout onLogout={onLogout} returnLink="/avaliador" carregando={carregando} usuario={usuario} empresa={empresaLogin} permissoes={modulosPermitidos} >
                <CssBaseline />
                <form onSubmit={this.handleSubmit} noValidate >
                    <VitalizePaper>
                        <Grid container spacing={1}>
                            <Grid item xs={12} >
                                <LabelSecao label="Avaliador" />
                            </Grid>
                            {
                                this.renderCampoEmpresas(permiteSelecionarEmpresa, empresa, empresaErro, empresas)
                            }
                            <Grid item xs={12} >
                                <TextField 
                                    name="nome" 
                                    label="Nome" 
                                    type="text" 
                                    placeholder="Nome do avaliador" 
                                    required
                                    variant="outlined" 
                                    fullWidth 
                                    error={!!nomeErro}
                                    helperText={nomeErro}
                                    value={nome} 
                                    onChange={this.handleChange} 
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} >
                                <TextField 
                                    name="email" 
                                    label="E-mail" 
                                    type="email" 
                                    placeholder="E-mail do avaliador" 
                                    required={false}
                                    variant="outlined" 
                                    fullWidth 
                                    error={!!emailErro}
                                    helperText={emailErro}
                                    value={email} 
                                    onChange={this.handleChange} 
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} >
                                <TextField 
                                    name="telefone" 
                                    label="Telefone" 
                                    type="phone" 
                                    placeholder="Telefone do avaliador" 
                                    required={false}
                                    variant="outlined" 
                                    fullWidth 
                                    InputProps={{ inputComponent: MaskedInput, inputProps: { mask:[ '(', /\d/, /\d/, ')', ' ', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/ ] } }}
                                    error={!!telefoneErro}
                                    helperText={telefoneErro}
                                    value={telefone} 
                                    onChange={this.handleChange} 
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} >
                                <TextField 
                                    name="senha" 
                                    label="Senha" 
                                    type="password" 
                                    placeholder="Senha do avaliador"
                                    required={this.getId() === 0}
                                    variant="outlined" 
                                    fullWidth 
                                    error={!!senhaErro}
                                    helperText={senhaHelper}
                                    value={senha} 
                                    onChange={this.handleChange} 
                                />
                            </Grid>
                        </Grid>
                    </VitalizePaper>
                    <FormControl component={VitalizePaper} error={!!permissoesErro} id="select-permissoes" className={classes.secaoPermissoes} >
                        <Grid container spacing={1}>
                            <Grid item xs={12} >
                                <FormLabel><LabelSecao label="Permissões" /></FormLabel>
                            </Grid>
                            <FormGroup className={classes.grupoPermissoes}>
                                {
                                    permissoes.map(permissao => (
                                        <Grid key={permissao.id} item xs={12} sm={6} md={3} >
                                            <FormControlLabel
                                                control={<Checkbox checked={this.verificarPermissaoSelecionada(permissao)} onChange={this.handlePermissoesChange} value={permissao.id} />}
                                                label={permissao.descricao}
                                            />
                                        </Grid>
                                    ))
                                }
                            </FormGroup>
                            <FormHelperText>{permissoesErro}</FormHelperText>
                        </Grid>
                    </FormControl>
                    <VitalizeFab color="primary" variant="extended" type="submit" loading={processando} >
                            Salvar
                    </VitalizeFab>
                </form>
            </Layout>
        );
    }
}

AvaliadorFormPage.propTypes = {
    /** Evento disparado quando o usuário realiza o logout */
    onLogout: PropTypes.func,
    /** Dados do usuário autenticado */
    usuario: PropTypes.object.isRequired,
    /** Empresa relacionada ao usuário */
    empresa: PropTypes.object,
    /** Objeto contendo as permissões do usuário */
    permissoes: PropTypes.object.isRequired,
    /** Parâmetros da URL */
    match: PropTypes.shape({
        params: PropTypes.shape({
            /** Id do avaliador a ser editado */
            id: PropTypes.string
        })
    }),
    /** Classes CSS da página */
    classes: PropTypes.shape({
        secaoPermissoes: PropTypes.string,
        grupoPermissoes: PropTypes.string
    })
};

export default withStyles(styles)(AvaliadorFormPage);